export default __webpack_public_path__ + "static/media/doneIcon.c830ebc5.svg";